import React from 'react';

const WarningMessage = ({ message = '' }) => (
  <div className="info">
    <p className="infoText" dangerouslySetInnerHTML={{ __html: message }} />
  </div>
);

export default WarningMessage;
